import React from 'react'
import PropTypes from 'prop-types'
import { Map, List } from 'immutable'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'
import InvoiceTableTextRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/text'
import SelectPayment, { NEW_PAYMENT_METHOD_VALUE } from '@aytm/lib/rfd-ui/components/payment/select-payment'

export default class InvoiceTablePaymentMethodRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    updateData: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func
  }

  constructor(...args) {
    super(...args)
    this.onSelect = this.onSelect.bind(this)
    this.updateNewCreditCard = this.updateNewCreditCard.bind(this)
  }

  onSelect(pm) {
    const { onChange, row } = this.props
    const id = row.get('id')

    if (id && 'function' == typeof onChange) {
      onChange(
        Map({
          [id]: Map({
            type: 'paymentMethod',
            error: false,
            value: Map({
              id: pm.get('id'),
              new: Boolean(pm.get('newPaymentMethod'))
            })
          })
        }),
        id,
        false !== row.get('update')
      )
    }
    //TO THINK
    //return false
  }

  updateNewCreditCard(save = false) {
    return (data, Promise) => {
      const { onChange, row } = this.props
      const id = row.get('id')
      if (id && 'function' == typeof onChange) {
        onChange(
          Map({
            [id]: Map({
              type: 'paymentMethod',
              value: Map({
                id: NEW_PAYMENT_METHOD_VALUE.get('id'),
                new: true
              }).merge(Map.isMap(data) && null != data.get('token') ? { cardData: data } : {})
            })
          }),
          id,
          save
        )
        return false
      } else
        return new Promise((resolve /*, reject*/) => {
          resolve(true)
        })
    }
  }

  renderSelector() {
    const { row, width, updateData } = this.props
    const paymentMethods = row.get('paymentMethods') || List()
    const id = row.get('id')
    const value = updateData.hasIn([id, 'value', 'id'])
      ? updateData.getIn([id, 'value', 'id'])
      : row.get('defaultPaymentMethod')
    const newCCBy = row.get('newCCBy')

    return (
      <SelectPayment
        width={width}
        options={paymentMethods}
        value={value}
        placeholder={row.get('placeholder')}
        onSelect={this.onSelect}
        error={row.get('error')}
        showSelected={row.get('showselected')}
        newCreditCardBy={Map.isMap(newCCBy) ? newCCBy.set('save', this.updateNewCreditCard(true)) : null}
        isEmpty={true}
      />
    )
  }

  componentDidUpdate(prevProps) {
    // check if payment methods changed and adjust value if needed
    if (this.props.row !== prevProps.row) {
      const prevPaymentMethods = prevProps.row.get('paymentMethods') || List()
      const nextPaymentMethods = this.props.row.get('paymentMethods') || List()
      if (prevPaymentMethods !== nextPaymentMethods) {
        const nextID = this.props.row.get('id')
        const nextValue = this.props.updateData.hasIn([nextID, 'value', 'id'])
          ? this.props.updateData.getIn([nextID, 'value', 'id'])
          : this.props.row.get('defaultPaymentMethod')
        if (
          nextValue !== NEW_PAYMENT_METHOD_VALUE.get('id') &&
          !nextPaymentMethods.some(pm => pm.get('id') === nextValue)
        ) {
          this.onSelect(nextPaymentMethods.get(0, NEW_PAYMENT_METHOD_VALUE))
        }
      }
    }
  }

  render() {
    const { row, width, valuesWidth } = this.props

    return (
      <div className="rfd-ui-invoice-table-row-container">
        {row.has('text') && <InvoiceTableTextRow row={row} width={width} valuesWidth={valuesWidth} />}
        {this.renderSelector()}
        {row.has('note') && (
          <div className="rfd-ui-invoice-table-row-value" style={{ width: valuesWidth }}>
            <div
              className="rfd-ui-invoice-table-row-value-text"
              dangerouslySetInnerHTML={{ __html: this.preprocessText(row.get('note')) }}
            />
          </div>
        )}
      </div>
    )
  }
}
